<h1 class="header">{{ currentComponentName$ | async }}</h1>
